// extracted by mini-css-extract-plugin
export default {"pairSecondRow":"ETcfn2bE1At_zKdNW54c"};